module.exports = __webpack_public_path__ + "img/video12.5fb75be1.jpg";